import { jsxs as n, jsx as f } from "react/jsx-runtime";
import { twMerge as a } from "tailwind-merge";
function x({
  wrapperAs: t = "div",
  wrapperProps: c = { className: "flex justify-between gap-2" },
  label: s,
  required: e,
  labelClassName: i,
  labelRightElement: r,
  requiredSignClassName: p
}) {
  return s || e || r ? /* @__PURE__ */ n(t, { ...c, children: [
    (s || e) && /* @__PURE__ */ n("span", { className: a("flex", i), children: [
      s,
      " ",
      e && /* @__PURE__ */ f("i", { className: a("text-danger", p), children: "*" })
    ] }),
    r
  ] }) : null;
}
export {
  x as FieldLabel
};
